import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { ThemePalette } from '@angular/material/core';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute } from '@angular/router';
import { faArrowUp, faChevronUp, faList, faSearch, faTimes } from '@fortawesome/free-solid-svg-icons';
import { ItemRss } from 'app/shared/models/itemRss/itemRss';
import { Ligue } from 'app/shared/models/List-Ligue/list-ligue';
import { DataService } from 'app/shared/services/data/data.service';
import { FfvapiService } from 'app/shared/services/ffvApi/ffvapi.service';
import { SearchFilterService } from 'app/shared/services/search-filter/search-filter.service';
import { TitleService } from 'app/shared/services/title/title.service';
import { UserService } from 'app/shared/services/user/user.service';
import { SubscriptionBaseComponent } from 'app/shared/subscriptionBase/subscription-base';
import { ChoiceLigueComponent } from './choice-ligue/choice-ligue.component';

@Component({
  selector: 'app-actu-ligue',
  templateUrl: './actu-ligue.component.html',
  styleUrls: ['./actu-ligue.component.scss']
})
export class ActuLigueComponent extends SubscriptionBaseComponent implements OnInit {

  faList = faList;
  faTimes = faTimes;
  faSearch = faSearch;
  faArrowUp = faArrowUp;
  faChevronUp = faChevronUp;


  searchForm: FormGroup;
  valueInput: string;

  itemsFlux: ItemRss[] = [];
  itemsFluxFilter = [];
  allLigues: Ligue[];
  myLigues: Ligue[];
  noFlux = false;
  newLigue: Ligue = null;
  color: ThemePalette = 'primary';
  load = false;
  codeLigueSave: number;

  constructor(
    private formBuilder: FormBuilder,
    private filterService: SearchFilterService,
    private titleService: TitleService,
    private dataService: DataService,
    private userService: UserService,
    private ffvService: FfvapiService,
    private cdr: ChangeDetectorRef,
    private dialog: MatDialog,
    private route: ActivatedRoute
  ) {
    super();
  }

  ngOnInit(): void {
    this.titleService.title.next('Actus Ligue');
    this.initForm();
    this.initSub();
    // this.getUserDetails();
    this.getLigues();
    // this.choiceLigueInList();
    // this.getFluxRss();
  }

  scrollToElement(): void {
    document.querySelector('#target').scrollIntoView({ behavior: 'smooth' });
    // $element.scrollIntoView({ behavior: 'smooth', block: 'end', inline: 'nearest' });
  }

  applyFilter(filterValue: string): void {

    this.valueInput = filterValue;
    this.itemsFluxFilter = [];
    this.filterFlux(filterValue);
    this.resetFlux(this.itemsFlux);
  }

  resetSearch(): void {
    this.searchForm.get('keyword').setValue('');
    this.applyFilter('');
  }

  choiceLigueInList() {
    this.load = true;

    const dialogRef = this.dialog.open(ChoiceLigueComponent, {
      data: { allLigues: this.allLigues, codeLigueSave: this.codeLigueSave, fluxLigue: this.newLigue, load: this.load },
      disableClose: true
    });

    dialogRef.afterClosed().subscribe(res => {
      const obj = this.allLigues.find(item => item.denomination === res);
      if (typeof res === 'boolean') {
        this.load = res;
      } else {
        this.codeLigueSave = obj.idLigue;
        this.getMyLigue(obj.code);
      }
    });
  }

  private getLigues(): void {
    this.userService.getFluxRssLigues().subscribe(res => {
      this.allLigues = res.allLigues;
      this.codeLigueSave = res.chosenIdLigue;
      this.itemsFlux = res.userLigueItems;
    }, error => {
      this.getUserDetails();
    });
  }


  private initForm(): void {
    this.searchForm = this.formBuilder.group({
      keyword: ['']
    });
  }

  private get f(): object {
    return this.searchForm.controls;
  }

  private resetFlux(flux: any): void {
    this.itemsFlux = flux;
  }

  private filterFlux(filterValue: string): void {
    this.itemsFluxFilter = this.filterService.filter(this.itemsFlux, filterValue);
  }

  private getMyLigue(code: string): void {
    const pers = this.route.snapshot.params.addPers;
    const fonc = this.route.snapshot.params.addFonc;

    this.userService.getFluxRssMyLigue(code, pers, fonc).subscribe(res => {
      this.itemsFlux = res;
      this.noFlux = false;
      this.load = false;

    }, error => {
      this.getMyLigue(this.codeLigueSave.toString());
      this.load = false;
      this.noFlux = true;
    });
  }

  private getUserDetails(): void {
    let code: string;
    this.ffvService.getDetailsUser().subscribe(res => {
      code = res.liguE_CODE;
    });
    this.getMyLigue(code);
  }

  private initSub(): void {
    this.subscription
      .add(
        this.dataService.keyword.asObservable().subscribe(kw => {
          this.searchForm.get('keyword').setValue(kw);
          this.applyFilter(kw);
          this.cdr.detectChanges();
        })
      );
  }

}
